import React from 'react';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { SelectField, SmallBodyText } from '../../../../../ui-toolkit';
import { DisplaySolarPanels } from '../../../../../ui-toolkit/orders/interfaces/eSolarPanels';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { optionsFromDisplay } from '../../../../../ui-toolkit/enums/optionsFromDisplay';

export const SolarPanels: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithEdit
      label={'Solar Panels'}
      tab={`other`}
      field={`solar_panels`}
      onUpdate={(_, value) => onPatchOrderInformation({ solarPanels: value ?? null })}
      order={order}
      editControl={SelectField}
      editProps={{ options: optionsFromDisplay(DisplaySolarPanels), isClearable: true }}
    >
      {order.transaction.solar_panels ? (
        DisplaySolarPanels[order.transaction.solar_panels]
      ) : (
        <SmallBodyText intent={`faded`}>-</SmallBodyText>
      )}
    </SummaryItemWithEdit>
  );
};
